import React, { useRef } from "react";
import { useParams, Navigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import PositionDetail from "../../../components/sections/partials/PositionDetail";
import Seo from "../../../seo/Seo";
import { jobs } from "../../../data/jobs";

const PositionPage = () => {
  const childRef = useRef();
  const { slug } = useParams();

  const job = jobs.find((j) => j.slug === slug);

  if (!job) {
    return <Navigate to="/careers" replace />;
  }

  const contentMessage = (
    <div className="text-xs my-0">
      {(job.location || job.jobType) && (
        <ul className="m-0 p-0" style={{ listStyle: "none" }}>
          {job.location && (
            <li className="m-0">
              <b>Location:</b> {job.location}
            </li>
          )}
          {job.jobType && (
            <li className="m-0">
              <b>Job Type:</b> {job.jobType}
            </li>
          )}
        </ul>
      )}
      {job.intro && <ReactMarkdown>{job.intro}</ReactMarkdown>}
    </div>
  );

  const renderMarkdown = (text) =>
    text ? <ReactMarkdown>{text}</ReactMarkdown> : null;

  const seoDescription = job.intro
    ? job.intro.replace(/\s+/g, " ").trim().slice(0, 160)
    : `${job.title} position at Trade Square.`;

  return (
    <>
      <Seo
        title={job.title}
        description={seoDescription}
        canonical={`/careers/${slug}`}
        type="article"
      />
    <PositionDetail
      childRef={childRef}
      positionName={job.title}
      contentMessage={contentMessage}
      jobDescriptionsTitle={job.jobDescriptions ? "Job Descriptions" : null}
      jobDescriptionsContent={renderMarkdown(job.jobDescriptions)}
      responsibilitiesTitle={job.responsibilities ? "Responsibilities" : null}
      responsibilitiesContent={renderMarkdown(job.responsibilities)}
      requirementsTitle={job.requirements ? "Requirements" : null}
      requirementsContent={renderMarkdown(job.requirements)}
      benefitsTitle={job.benefits ? "Benefits" : null}
      benefitsContent={renderMarkdown(job.benefits)}
      applyNowTitle="Apply Now"
      applyNowContent={
        <p className="text-xs my-0">
          <li className="m-0">
            <b>Email:</b> {job.applyEmail}
          </li>
          <li className="m-0">
            <b>Tel:</b> {job.applyPhone}
          </li>
        </p>
      }
      previousPageText="Careers"
      previousPageLink="/careers"
    />
    </>
  );
};

export default PositionPage;
